<template>
	<div class="container">
		<div>
			<div :style="textStyle">
				<h5>Sélection de la vidéo</h5>
			</div>
			<div class="m-0">
				<div class="ml-2">
					<flickity v-if="this.carouselVideos.length > 0" :options="flickityOptions">
						<ul class="carousel-cell" v-for="(video, index) in this.carouselVideos" :key="index">
							<video class="video-player" controls>
								<source :src="video.url">
							</video>
							<p>{{ video.name.replace(/_/g, " ") }}</p>
							<div class="outro-checkbox">
								<input class="checkbox_outros"
									type="checkbox"
									v-model="video.checked"
									:id="index"
									:value="video"
									@click="setVideo(video)"
									ref="checkboxOutros">
							</div>
						</ul>
					</flickity>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<ValidStep :id="this.id"
					:outroId="this.outroId" />
			</div>
		</div>
	</div>
</template>

<script>
import Flickity from "vue-flickity";
import ValidStep from "../ui/buttons/ValidStepVideo";
import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Video",
	components: {ValidStep, Flickity},
	props: {
		id: Number,
		stepName: String,
		projectId: Number,
		stepIndex: Number,
		renderId: String,
		outroId: Number,
		videoId: Number,
		isVisible: Boolean,
		isCompleted: Boolean,
	},
	data() {
		return {
			carouselVideos: [],
			arrayCheck: [],
			flickityOptions: {
				initialIndex: 1,
				prevNextButtons: true,
				pageDots: false,
				wrapAround: false,
				draggable: false,
			},
			textStyle: {
				"color": process.env.VUE_APP_PRIMARY_COLOR,
				"marginTop": "3rem",
				"marginBottom": "20px",
			},
		};
	},
	activated() {
		this.getOutroVideos();
	},
	methods: {
		getOutroVideos() {
			this.carouselVideos = [];
			let $this = this;
			axios.get(BASE_URL + "/public/api/outros/" + this.id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				let data = response.data.data.outros;

				data.forEach(function (element) {
					if (element.id === Number($this.outroId)) {
						element.checked = "checked";
					}
					$this.carouselVideos.push(element);
				});
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		next() {
			this.$refs.flickity.next();
		},
		previous() {
			this.$refs.flickity.previous();
		},
		setVideo(video) {
			this.outroId = video.id;
			this.carouselVideos.forEach(function (element) {
				if (video.id !== element.id) {
					element.checked = false;
				}
			});
		},
	},
};
</script>

<style scoped>
.video-player {
	width: 320px;
	height: 320px;
	border-radius: var(--small-border-radius);
}

.carousel-cell:first-child {
	padding-left: 0;
}

.carousel-cell {
	margin: 0;
	padding-left: 20px;
}

.carousel-cell p {
	text-align: center;
}

h5 {
	color: #004F9E;
}

.outro-checkbox {
	text-align: center;
}

.checkbox_outros {
	height: 20px;
	width: 20px;
}
</style>
